import { useEffect, useState } from 'react';
import { getDataAgainstPokusKey } from '../module/pokusController';
import { RAILS_POKUS } from '../utils/RailsSEOConstants';

export function usePokusApi(pokusKey, defaultPokusValue) {
  const [pokusData, setPokusData] = useState(false);

  useEffect(() => {
    async function getPokusData() {
      try {
        const PokusData = await getDataAgainstPokusKey(pokusKey);
        setPokusData(PokusData);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(RAILS_POKUS.pokusFetchError, error);
        setPokusData(defaultPokusValue);
      }
    }
    getPokusData();
  }, []);

  return pokusData;
}

export default usePokusApi;
